/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./App.vue.js?vue&type=template&id=1586171a!=!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=1586171a"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports